import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "Home" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "屏幕分享", -1)
const _hoisted_4 = {
  ref: "version",
  class: "version"
}
const _hoisted_5 = {
  key: 0,
  class: "btns"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 创建房间 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode()
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 进入房间 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HanButton = _resolveComponent("HanButton")!
  const _component_CreateRoomComponent = _resolveComponent("CreateRoomComponent")!
  const _component_EnterRoomComponent = _resolveComponent("EnterRoomComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", _hoisted_4, null, 512),
      (!$setup.action)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_HanButton, { onClick: $setup.createRoom }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["onClick"]),
            _hoisted_7,
            _hoisted_8,
            _createVNode(_component_HanButton, {
              color: "blue",
              onClick: $setup.enterRoom
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : ($setup.action === 'create')
          ? (_openBlock(), _createBlock(_component_CreateRoomComponent, {
              key: 1,
              onBack: $setup.back
            }, null, 8, ["onBack"]))
          : ($setup.action === 'enter')
            ? (_openBlock(), _createBlock(_component_EnterRoomComponent, {
                key: 2,
                onBack: $setup.back
              }, null, 8, ["onBack"]))
            : _createCommentVNode("", true)
    ])
  ]))
}